import { extractRootHtmlElement as y } from "@scalar-org/vue-render";
import { resolveAndFetchIcon as h } from "./resolveAndFetchIcon.js";
async function z(t) {
  const e = u(t.src), a = u(t["src-dark"]);
  if (!e) return "";
  if (!a) return await g({ props: t, key: "src" });
  const [i, s] = await Promise.all([
    h(e),
    h(a)
  ]), m = i && !$(i), n = s && !$(s);
  if (m && n)
    return j({ props: t, standardSrc: e, darkSrc: a });
  const c = await g({
    props: t,
    key: "src",
    fetchedData: i
  }), o = await g({
    props: t,
    key: "src-dark",
    fetchedData: s
  });
  return `<span class='t-editor__icon'>${c}${o}</span>`.trim();
}
async function g({
  props: t,
  key: e,
  fetchedData: a
}) {
  const i = e === "src-dark", s = i ? "src" : "src-dark", m = !!(t[e] && t[s]), n = t[e], c = typeof n == "object" ? n.src : n;
  if (!c) return "";
  const o = a ?? await h(c), d = [...t.classes || []], f = m ? `data-visibility="${i ? "darkMode" : "lightMode"}"` : "";
  if (o) {
    const r = y(o);
    if (r.tagName === "svg") {
      const l = r.properties;
      return l.width = t.size || r.properties.width || "1em", l.height = t.size || r.properties.height || "1em", d.length && (l.class = d.join(" ")), `
      <svg ${f}
        ${Object.entries(l).map(([k, b]) => `${k}="${b}"`).join(" ")}>${r.innerHTML}</svg>
      `.trim();
    }
  }
  return `<img
  src="${c}"
  ${f}
  alt="${t.title ?? "Icon"}"
  style="${t.size ? `width: ${t.size}; height: ${t.size}; object-fit: contain;` : "object-fit: contain;"}"
  onerror="this.style.visibility='hidden'" ${d.length ? `class="${d.join(" ")}" ` : ""}/>`.trim();
}
function $(t) {
  return t ? y(t).tagName === "svg" : !1;
}
function j({
  props: t,
  standardSrc: e,
  darkSrc: a
}) {
  const i = t.classes?.join(" ") || "", s = t.size ? `width: ${t.size}; height: ${t.size}; object-fit: contain;` : "object-fit: contain;";
  return `
<img
  src="${e}"
  data-dark-mode-src="${a}"
  data-scalar-type="image"
  data-scalar-name="scalar-image"
  data-src="${t.src}"
  alt="${t.title ?? "Icon"}"
  style="${s}"
  onerror="this.style.visibility='hidden'" ${i.length ? `class="${i}" ` : ""}/>
  `.trim();
}
function u(t) {
  if (t)
    return typeof t == "object" ? t.src : t;
}
export {
  z as guideIconHtml
};
